import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import SectionToggle from "../../../../../components/sectionToggle/sectionToggle";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import LoadingAnimation from "../../../../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "./redux/averageNumberOfVisitsPerClientSagas";
import "../../attendance_common.css.scss";
import LearnMore from "../../../../../components/learnMore/learnMore";
import { UpdateButtons } from "./smartComponents/UpdateButtons";
import GroupBy from "./smartComponents/GroupBy";
import LineOrTableChart from "./smartComponents/LineOrTableChart";
import OnlyMembership from "./smartComponents/OnlyMembership";
import ScoreCards from "./smartComponents/ScoreCards";
import CategoriesFilter from "./smartComponents/CategoriesFilter";

const AverageNumberOfVisitsPerClientModule = ({
  params,
  useSecondaryCategories,
  clientName = ""
}) => {
  const {
    isLoading,
    updatesLoading,
    primaryCategoriesLoading,
    secondaryCategoriesLoading,
    pricingOptionsLoading,
    filters,
    selectedFilters
  } = useSelector((state) => state.averageNumberOfVisitsPerClient);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(params));
  }, []);
  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div className={`top-left-filter ${useSecondaryCategories ? "" : "extend"}`}>
              {useSecondaryCategories && (
                <CategoriesFilter
                  selected={selectedFilters.primary_categories}
                  options={filters.primary_categories}
                  action={"updatePrimaryCategory"}
                  loader={primaryCategoriesLoading}
                  name={"Primary Category"}
                />
              )}
              <CategoriesFilter
                selected={selectedFilters.secondary_categories}
                options={filters.secondary_categories}
                action={"updateSecondaryCategory"}
                loader={secondaryCategoriesLoading}
                name={`${useSecondaryCategories ? "Secondary" : ""} Category`}
              />
              <CategoriesFilter
                selected={selectedFilters.pricing_options}
                options={filters.pricing_options}
                action={"updatePricingOption"}
                loader={pricingOptionsLoading}
                name={"Pricing Option"}
              />
              <div className="select-box-no-width">
                <p>Group By</p>
                <GroupBy />
              </div>
            </div>
            <div className="top-filter__right">
              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>
              <div className="date-select-box monthly">
                <p>Date</p>
                <DatePicker />
              </div>
              {<UpdateButtons />}
            </div>
          </div>
          <div className="bottom-filter">
            <div className="select-box-no-width">
              <p>Show Membership Only </p>
              <OnlyMembership />
            </div>
          </div>
        </div>

        <div data-testid={"charts-container"} className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <>
              {selectedFilters.only_memberships &&
              !selectedFilters.primary_categories.length &&
              !selectedFilters.secondary_categories.length ? (
                <div className="error error--big">No Membership Visits</div>
              ) : (
                <>
                  <ScoreCards />
                  <LineOrTableChart />
                </>
              )}
            </>
          )}
        </div>
      </div>
    );
  };
  const title = "Average Number of Visits";
  return (
    <div id="attendance-root">
      <SectionToggle
        paddingBottom={0}
        height={690}
        title={title}
        isLoading={isLoading}
        learnMore={<LearnMore {...learnMore(title, clientName)} />}
        content={content()}
      />
    </div>
  );
};

const learnMore = (title, clientName) => {
  const client = clientName.toLowerCase();
  return {
    title,
    customStyles: { width: "660px" },
    content: `Shows the number of times ${client} came on average to class/appointment/arrivals in the given time period.`
  };
};
export default AverageNumberOfVisitsPerClientModule;

AverageNumberOfVisitsPerClientModule.propTypes = {
  params: PropTypes.object,
  useSecondaryCategories: PropTypes.bool,
  clientName: PropTypes.string
};
